import React from 'react';
import {
  SelectedEntities,
} from '../../../components';
import { VACANCY_OVERVIEW_URL } from '../../../config/constants';

const ParagraphSelectedVacancies = ({ id, entity }) => {
  return (
    <SelectedEntities
      id={id}
      type="vacancies"
      link={VACANCY_OVERVIEW_URL}
      entities={entity.getIn(['field_selected_vacancies'])}
      title={entity.getIn(['field_title', 0, 'value'])}
    />
  );
};

export default ParagraphSelectedVacancies;
